import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { JVFLogo } from "./Logo";

const LINKS = [
  { label: "Serviços", href: "/#servicos", testid: "nav-link-servicos" },
  { label: "Cotações", href: "/#cotacoes", testid: "nav-link-cotacoes" },
  { label: "Sobre", href: "/#sobre", testid: "nav-link-sobre" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-white/15 bg-black/85 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between px-6 lg:px-12">
        <JVFLogo />
        <nav className="hidden items-center gap-10 md:flex" data-testid="nav-desktop">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testid}
              className="font-mono text-xs uppercase tracking-[0.25em] text-white/70 transition-colors duration-300 hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <a
            href="/contato"
            data-testid="nav-cta-contato"
            className="border border-white/40 px-5 py-2 font-mono text-xs uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white hover:text-black"
          >
            Contato
          </a>
        </nav>
        <button
          className="text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-menu-button"
          aria-label="Abrir menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden border-t border-white/15 md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-6 px-6 py-8">
              {LINKS.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  data-testid={`${link.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className="font-oswald text-2xl uppercase tracking-wide text-white/80"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="/contato"
                data-testid="nav-cta-contato-mobile"
                onClick={() => setOpen(false)}
                className="font-oswald text-2xl uppercase tracking-wide text-white"
              >
                Contato
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
